import { PatientActions } from 'src/redux/actions/constant';

const {
  RESET_CREATE_PATIENT,
  SUCCESS_CREATE_PATIENT,
  FAILURE_CREATE_PATIENT,
  LOADING_CREATE_PATIENT,
} = PatientActions;

const intitialstate: object = {
  isPatientCreated: false,
  response: null,
  loading: false,
};

export const createPatientReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_CREATE_PATIENT: {
      return {
        ...state,
        isPatientCreated: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_CREATE_PATIENT:
      return {
        ...state,
        isPatientCreated: false,
        response: action.payload,
        loading: false,
      };

    case LOADING_CREATE_PATIENT:
      return {
        ...state,
        loading: true,
      };

    case RESET_CREATE_PATIENT:
      return intitialstate;

    default:
      return state;
  }
};
